import style from "./Cards.module.css";
import currency from "../images/image-currency.jpg";
import restaurant from "../images/image-restaurant.jpg";
import plane from "../images/image-plane.jpg";
import confetti from "../images/image-confetti.jpg";
const Cards = () => {
  const cardList = [
    {
      img: currency,
      name: "By Claire Robinson",
      title: "Receive money in any currency with no fees",
      info: "The world is getting smaller and we're becoming more mobile. So why should you be forced to only receive money in a single ...",
    },
    {
      img: restaurant,
      name: "By Claire Robinson",
      title: "Receive money in any currency with no fees",
      info: "The world is getting smaller and we're becoming more mobile. So why should you be forced to only receive money in a single ...",
    },
    {
      img: plane,
      name: "By Claire Robinson",
      title: "Receive money in any currency with no fees",
      info: "The world is getting smaller and we're becoming more mobile. So why should you be forced to only receive money in a single ...",
    },
    {
      img: confetti,
      name: "By Claire Robinson",
      title: "Receive money in any currency with no fees",
      info: "The world is getting smaller and we're becoming more mobile. So why should you be forced to only receive money in a single ...",
    },
  ];
  return (
    <div className={style.cardsContainer}>
        {cardList.map(e=> 
      <figure className={style.card}>
        <img src={e.img} alt="currency" />
        <figcaption>
          <span className={style.name}>{e.name}</span>
          <h3 className={style.title}>{e.title}</h3>
          <p className={style.info}>{e.info}</p>
        </figcaption>
      </figure>
        )}
    </div>
  );
};

export default Cards;
